import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import ValidatedInput from "integrations/aws/common/ValidatedInput";
import FormWrap from "integrations/aws/common/FormWrap";
import { ApiRoutes } from "integrations/aws/common/Routes";
import { renderOptions } from "integrations/aws/common/Options";
import useFetch from "integrations/hooks/useFetch";
import formValidation from "integrations/aws/utils/formValidation";
import FormDataContext from "integrations/contexts/FormDataContext";
import { ApiContext } from "integrations/aws/context/Api";
import { toAWSRequest } from "integrations/aws/common/formDataAdapter";
import SetupModal from "./setup-steps/SetupModal";
const BackButton = styled(Button)`
  margin-right: 9px;
`;
const KinesisSetup = ({ onChange, onSubmit, toggleSetup = null }) => {
  const { availableGroups, setGroups, clearLogData } = useContext(ApiContext);
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const [disabledForm, setDisabledForm] = useState(false);
  const [disabledGroups, setDisabledGroups] = useState(false);
  const [showTOS, setShowTOS] = useState(false);
  const [groupNamesStatus, setGroupNamesUrl] = useFetch(
    ApiRoutes.INTEGRATIONS.AWS.CLOUDWATCH.GROUPS,
    (response) => {
      setGroups(response);
    },
    "POST",
    toAWSRequest(formData, { region: formData.awsCloudWatchAwsRegion.value })
  );
  useEffect(() => {
    if (groupNamesStatus.error) {
      setGroupNamesUrl(null);
      const noGroups = /No CloudWatch log groups/g;
      if (groupNamesStatus.error.match(noGroups)) {
        setFormError({
          full_message: groupNamesStatus.error,
          nice_message: /* @__PURE__ */ React.createElement("span", null, "We're unable to find any groups in your chosen region. Please try selecting a different region.")
        });
        setDisabledGroups(true);
      } else {
        setFormError({
          full_message: groupNamesStatus.error
        });
      }
    }
    return () => {
      setGroups({ log_groups: [] });
    };
  }, [groupNamesStatus.error, setGroupNamesUrl, setGroups]);
  const handleAgreeSubmit = () => {
    clearLogData();
    onSubmit();
  };
  const handleFormSubmit = () => {
    setDisabledForm(true);
    setShowTOS(true);
  };
  const handleAgreeCancel = () => {
    setDisabledForm(false);
    setShowTOS(false);
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleFormSubmit,
      buttonContent: "Begin Automated Setup",
      disabled: formValidation.isFormValid(["awsCloudWatchKinesisStream", "awsCloudWatchAwsGroupName"], formData) || disabledForm,
      loading: groupNamesStatus.loading,
      error: formError,
      title: "Set Up Kinesis Automatically",
      description: ""
    },
    /* @__PURE__ */ React.createElement("p", null, "Complete the fields below to start the automated Kinesis setup. This will perform the following operations within your AWS account. See", " ", /* @__PURE__ */ React.createElement(
      "a",
      {
        target: "_blank",
        rel: "noopener noreferrer",
        href: "https://docs.aws.amazon.com/AmazonCloudWatch/latest/logs/SubscriptionFilters.html"
      },
      "Using CloudWatch Logs Subscription Filters"
    ), " ", "in the AWS documentation for more information."),
    /* @__PURE__ */ React.createElement("ol", null, /* @__PURE__ */ React.createElement("li", null, "Create a new Kinesis stream with the specified name."), /* @__PURE__ */ React.createElement("li", null, "Create the IAM role/policy needed to subscribe the Kinesis stream to the CloudWatch Log Group."), /* @__PURE__ */ React.createElement("li", null, "Subscribe the new Kinesis stream to the Log Group.")),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "awsCloudWatchKinesisStream",
        type: "text",
        label: "Kinesis Stream Name",
        placeholder: "Stream Name",
        onChange,
        fieldData: formData.awsCloudWatchKinesisStream,
        disabled: disabledForm,
        pattern: "[a-zA-Z0-9_.-]{1,128}$",
        help: "1-128 alphanumeric characters and special characters underscore (_), period (.), and hyphen (-).",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "awsCloudWatchAwsGroupName",
        type: "select",
        fieldData: formData.awsCloudWatchAwsGroupName,
        onChange,
        label: "CloudWatch Group Name",
        required: true,
        disabled: groupNamesStatus.loading || disabledGroups || disabledForm
      },
      renderOptions(availableGroups, "Choose CloudWatch Group", groupNamesStatus.loading)
    ),
    toggleSetup && /* @__PURE__ */ React.createElement(BackButton, { onClick: toggleSetup, type: "button", disabled: disabledForm }, "Back to stream Selection"),
    showTOS && /* @__PURE__ */ React.createElement(
      SetupModal,
      {
        onSubmit: handleAgreeSubmit,
        onCancel: handleAgreeCancel,
        groupName: formData.awsCloudWatchAwsGroupName.value,
        streamName: formData.awsCloudWatchKinesisStream.value
      }
    )
  );
};
export default KinesisSetup;
